import type { ReactNode } from "react";

import { cardStyles } from "../../core/Card.styles.js";
import { cn } from "../../foundations/cn.js";
import { BattleSeat } from "./BattleSeat.js";
import type { BattleSeatView } from "./battleTypes.js";

export interface BattleSeatCardProps {
  /** "Seat 1". */
  seatLabel: string;
  seat: BattleSeatView;
  /** What the viewer can do with the seat: Join seat, Add bot, Sign in to join. */
  actions?: ReactNode;
  className?: string;
}

/**
 * A seat in a battle that hasn't started: who holds it, or a dashed card with the ways to fill it.
 */
export function BattleSeatCard({ seatLabel, seat, actions, className }: BattleSeatCardProps) {
  const empty = seat.kind === "empty";
  return (
    <div
      className={cardStyles({
        radius: "2xl",
        fill: empty ? "none" : "surface",
        edge: empty ? "dashed" : "default",
        className: cn(
          "flex min-h-36 min-w-0 flex-col items-center justify-center gap-3 p-4 text-center",
          className,
        ),
      })}
    >
      <span className="font-body text-caption-eyebrow text-text-tertiary uppercase">
        {seatLabel}
      </span>
      <BattleSeat seat={seat} layout="stacked" size="md" />
      {actions && <div className="flex flex-wrap justify-center gap-2">{actions}</div>}
    </div>
  );
}
